import { useEffect, useState } from "react";

const useClickStats = (): { clicks: number } => {
  const [clicks, setClicks] = useState<number>(0);

  useEffect(() => {
    const handleClick = () => {
      setClicks((prev) => prev + 1);
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  return { clicks };
};

export default useClickStats;
